// extracted by mini-css-extract-plugin
module.exports = {"colorsDefault":"#fff","colorsRed":"#ff9476","colorsYellow":"#ffffb9","colorsBlue":"#9bdbff","colorsGray":"#d4d4d4"};